module.exports = [
	{
		"name": "Mada",
		"url": "https://github.com/alif-type/mada",
		"interpolations": [
			{
				"style": "Regular",
				"weight": 368
			},
			{
				"style": "SemiBold",
				"weight": 600
			},
			{
				"style": "Bold",
				"weight": 824
			}
		]
	},
	{
		"name": "Source Serif Pro",
		"url": "https://github.com/adobe-fonts/source-serif-pro",
		"interpolations": [
			{
				"style": "ExtraLight",
				"weight": 0
			},
			{
				"style": "Light",
				"weight": 408
			},
			{
				"style": "Regular",
				"weight": 1041
			},
			{
				"style": "Semibold",
				"weight": 1367
			},
			{
				"style": "Bold",
				"weight": 1722
			},
			{
				"style": "Black",
				"weight": 2000
			}
		]
	},
	{
		"name": "Source Code Pro",
		"url": "https://github.com/rezerbit/.dotfiles",
		"interpolations": [
			{
				"style": "ExtraLight",
				"weight": 0
			},
			{
				"style": "Light",
				"weight": 100
			},
			{
				"style": "Regular",
				"weight": 368
			},
			{
				"style": "Medium",
				"weight": 486
			},
			{
				"style": "Semibold",
				"weight": 600
			},
			{
				"style": "Bold",
				"weight": 824
			},
			{
				"style": "Black",
				"weight": 1000
			}
		]
	},
	{
		"name": "Adobe VF Prototype",
		"url": "https://github.com/adobe-fonts/adobe-variable-font-prototype",
		"interpolations": [
			{
				"style": "ExtraLight",
				"weight": 0
			},
			{
				"style": "Light",
				"weight": 150
			},
			{
				"style": "Regular",
				"weight": 394
			},
			{
				"style": "Semibold",
				"weight": 600
			},
			{
				"style": "Bold",
				"weight": 824
			},
			{
				"style": "Black",
				"weight": 1000
			},
			{
				"style": "Black Medium Contrast",
				"weight": 1000
			},
			{
				"style": "Black High Contrast",
				"weight": 1000
			}
		]
	},
	{
		"name": "Source Hebrew Sans",
		"url": "https://github.com/adobe-fonts/source-hebrew-sans",
		"interpolations": [
			{
				"style": "ExtraLight",
				"weight": 0
			},
			{
				"style": "Light",
				"weight": 100
			},
			{
				"style": "Regular",
				"weight": 368
			},
			{
				"style": "Semibold",
				"weight": 600
			},
			{
				"style": "Bold",
				"weight": 824
			},
			{
				"style": "Black",
				"weight": 1000
			}
		]
	},
	{
		"name": "Atithi",
		"url": "https://github.com/jonpinhorn/atithi",
		"interpolations": [
			{
				"style": "ExtraLight",
				"weight": 0
			},
			{
				"style": "Light",
				"weight": 20
			},
			{
				"style": "Regular",
				"weight": 40
			},
			{
				"style": "Medium",
				"weight": 60
			},
			{
				"style": "SemiBold",
				"weight": 80
			},
			{
				"style": "Bold",
				"weight": 100
			}
		]
	},
	{
		"name": "Riter medium",
		"url": "https://github.com/shannpersand/cooper-type",
		"interpolations": [
			{
				"style": "x184.72",
				"weight": 165.966835
			},
			{
				"style": "x1429.26",
				"weight": 429.260254
			},
			{
				"style": "x1697.73",
				"weight": 697.72678
			}
		]
	},
	{
		"name": "Source Sans Pro",
		"url": "https://github.com/adobe-fonts/source-sans-pro",
		"interpolations": [
			{
				"style": "ExtraLight Italic",
				"weight": 0
			},
			{
				"style": "Light Italic",
				"weight": 100
			},
			{
				"style": "Italic",
				"weight": 368
			},
			{
				"style": "Semibold Italic",
				"weight": 600
			},
			{
				"style": "Bold Italic",
				"weight": 824
			},
			{
				"style": "Black Italic",
				"weight": 1000
			}
		]
	}
]


// WEBPACK FOOTER //
// ./src/data/fonts.js